import * as React from "react"
import {TaskFilter, TaskGroup, TaskInterface} from "../Todoist/Task";
import {Collection, GroupInterface, TimeFormatInterface} from "../Todoist/Main";
import {ProjectInterface} from "../Todoist/Projects";
import {ColorTypeInterface} from "../Todoist/Color";
import {CollectionHelper, TaskStatistic} from "../Todoist/App";

interface ReactTaskInterface {
    task: TaskInterface
}

export class Time extends React.Component<{time: TimeFormatInterface}, {}>{

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return ( <span>{this.props.time.toFormat().hour}ч {this.props.time.toFormat().minute}m  ({this.props.time.toTomato()}t)</span> );
    }
}


export class ReactTask extends React.Component<ReactTaskInterface, {}> {




    render() {
        return <div className={"task task_priority-"+this.props.task.getPriority().getId()}>

            <div className={"task-priority task-priority_"+this.props.task.getPriority().getId()}>
                <a href={"ewdw"} title={this.props.task.getPriority().getTitle()} className={"priority-line priority-line_task priority-line_type-"+this.props.task.getPriority().getId()}></a>
                <div className="row">
                    <div className="col-sm-9">
                        <div className="task__title">
                            {this.props.task.getTitle()}
                            <a target="_blank" href={this.props.task.getLink()}> &gt; </a>
                        </div>

                    </div>

                    <div className="col-sm-2">
                        <div className="task__time">
                            <Time time={this.props.task.time()}/>
                        </div>

                    </div>

                </div>
            <div className="row">

                <div className="col-lg-3">
                    <div className="task__type" >
                    <span className="type-point type-point_small" style={{background: this.props.task.getColor().getCode()}}></span>{this.props.task.getColor().getType()}
                    </div>

                </div>
                <div className="col-lg-3">
                    <div className="task__project-name">
                    #{this.props.task.getProject().getName()}
                    </div>

                </div>
                <div className="col-lg-3">{this.props.task.getDueDate().toLocaleString()}</div>

            </div>
            </div>

        </div>;
    }
}



interface ReactTasksInterface {
    tasks: Collection<TaskInterface>
}


export class ReactTasks extends React.Component<ReactTasksInterface, {}> {

    constructor(props: Readonly<ReactTasksInterface>) {
        super(props);
    }


    render() {
        return <div>
            {
                this.props.tasks.group<ProjectInterface>(item => item.getProject()).getItems().map(function (group) {



                    return <div key={group.group.getID()}><h3>{group.group.getName()}</h3>
                        <div><ReactTaskStat key={group.group.getID()} tasks={group.items}/></div>

                        {group.items.getItems().map(function (task) {
                        return  <ReactTask key={task.getId()} task={task}></ReactTask>
                    })}</div>
                })

            }


        </div>;
    }
}


export class ReactDayTasks extends React.Component{


    constructor(readonly props: {groupByDate: GroupInterface<Date, TaskInterface>}){
        super(props);
    }

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (
            <div className="tasks-of-day">

                <div className="tasks-of-day__wrapper">
                    <div className="row">

                        <div className="col-lg-12">
                            <div className="tasks-of-day__header">
                                {this.props.groupByDate.group.toLocaleString("default",{weekday: "long", day: "numeric", month: "long"})}
                            </div>

                            <ReactTaskStat tasks={this.props.groupByDate.items}/>




                        </div>


                    </div>

                    <div>

                        <ReactTasks tasks={this.props.groupByDate.items}/>


                    </div>


                </div>

            </div>);
    }
}



export class ReactTaskStat extends React.Component {

    private statistic: TaskStatistic;

    constructor(readonly props: {tasks: Collection<TaskInterface>}){
        super(props);
        this.statistic = new TaskStatistic(props.tasks)
    }

    componentWillReceiveProps(props:{tasks: Collection<TaskInterface>}){

        this.statistic = new TaskStatistic(props.tasks);


    }

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (<div className="tasks-statistic">

            <span className="tasks-statistic__full-time"><Time time={this.statistic.getFullTime()}/></span>
            {this.statistic.getTypeTime().map((item) =>{
                return <span key={item.color.getId()} className="tasks-statistic__color-type" style={{backgroundColor: item.color.getCode() }}> {item.color.getType()} <Time time={item.time}/> </span>
            })}

        </div>);
    }


}


export class ReactMain extends React.Component<{}, {isShowToday: boolean, tasks: Collection<TaskInterface>, day: number}> {

    constructor(readonly props: {tasks: Collection<TaskInterface>}){
        super(props);
        this.state = {
            tasks: props.tasks,
            day: 7,
            isShowToday: false
        }
    }

    handlerThisDay(){
        let day = this.state.isShowToday ? 7 : 1;
        this.setState({
            isShowToday: !this.state.isShowToday
            , day: day

        })

    }
    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {


        let TaskWeekToday  = this.state.tasks.filter(TaskFilter.maxDayShow(this.state.day));

        let TaskWeekTodayGroup = TaskWeekToday.group<Date>(TaskGroup.byDate());
        TaskWeekTodayGroup.getItems().sort(function (itemA, itemB) {
            return itemA.group < itemB.group ? -1 : 1;
        });

        return (

            <div>
                <div>
                    {TaskWeekTodayGroup.getItems().map((item, index) =>
                            <div key={index}>
                                <div>{item.group.toLocaleString("default", {weekday: "long"})}</div>
                            <ReactTaskStat key={index} tasks={item.items}/>
                            </div>

                        )}
                </div>
                <div className={"filter__item " + (this.state.isShowToday ? "filter__item_active" : "")} onClick={()=> this.handlerThisDay()}>Сегодня</div>
                {TaskWeekTodayGroup.getItems().map(function (itemGroup, index) {
                return <div key={index}  className="col-lg-12"><ReactDayTasks key={index} groupByDate={itemGroup}/></div>
            })}
            </div>
        );

    }


}